'use client';

import React from 'react';
import { RadialBarChart, RadialBar, ResponsiveContainer } from 'recharts';
import { FileText, AlertTriangle } from 'lucide-react';

// Backend integration point: GET /api/ehs/sds/coverage-summary
const coverageData = [
  { name: 'Coverage', value: 94.2, fill: '#22c55e' },
  { name: 'Gap', value: 5.8, fill: 'hsl(var(--muted))' },
];

const sdsStats = [
  { id: 'sds-total', label: 'Total Chemicals', value: '537', color: 'text-[hsl(var(--foreground))]' },
  { id: 'sds-current', label: 'Current SDS', value: '506', color: 'text-[hsl(var(--positive))]' },
  { id: 'sds-missing', label: 'Missing SDS', value: '31', color: 'text-[hsl(var(--negative))]' },
  { id: 'sds-expiring', label: 'Expiring 90d', value: '14', color: 'text-amber-500' },
];

export default function SDSCoverageGauge() {
  return (
    <div className="bg-[hsl(var(--card))] border border-[hsl(var(--border))] rounded-xl p-5 h-full flex flex-col">
      <div className="mb-3">
        <h3 className="text-sm font-600 text-[hsl(var(--foreground))]">SDS Coverage</h3>
        <p className="text-xs text-[hsl(var(--muted-foreground))] mt-0.5">Safety Data Sheets status</p>
      </div>
      <div className="relative flex-1 min-h-[140px]">
        <ResponsiveContainer width="100%" height="100%">
          <RadialBarChart
            cx="50%"
            cy="50%"
            innerRadius="60%"
            outerRadius="85%"
            barSize={12}
            data={[{ name: 'SDS Coverage', value: 94.2, fill: '#22c55e' }]}
            startAngle={180}
            endAngle={-180}
          >
            <RadialBar
              dataKey="value"
              cornerRadius={6}
              background={{ fill: 'hsl(var(--muted))' }}
            />
          </RadialBarChart>
        </ResponsiveContainer>
        <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none">
          <FileText size={16} className="text-[hsl(var(--positive))] mb-1" />
          <span className="text-2xl font-700 tabular-nums text-[hsl(var(--foreground))]">94.2%</span>
          <span className="text-[10px] text-[hsl(var(--muted-foreground))]">covered</span>
        </div>
      </div>
      <div className="grid grid-cols-2 gap-2 mt-3">
        {sdsStats?.map((stat) => (
          <div key={stat?.id} className="bg-[hsl(var(--muted)/0.5)] rounded-lg px-3 py-2">
            <p className="text-[10px] text-[hsl(var(--muted-foreground))] leading-tight">{stat?.label}</p>
            <p className={`text-base font-700 tabular-nums mt-0.5 ${stat?.color}`}>{stat?.value}</p>
          </div>
        ))}
      </div>
      <div className="flex items-center gap-1.5 mt-3 px-3 py-2 rounded-lg bg-amber-500/8 border border-amber-500/20">
        <AlertTriangle size={12} className="text-amber-500 shrink-0" />
        <p className="text-[11px] text-amber-500">14 SDS sheets expire within 90 days</p>
      </div>
    </div>
  );
}